import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';

interface CustomerDropdown {
  office?: any;
  customerID: any;
  page: any;
  onCustomerLoading: (data: boolean) => void;
  onSelectCustomer: (customerID: number) => void;
  onRebateValue: (rebateValue: string) => void;
}
export const CustomerDropdown = ({
  office,
  customerID,
  page,
  onCustomerLoading,
  onSelectCustomer,
  onRebateValue,
}: CustomerDropdown) => {
  const { setValue, getValues } = useFormContext();
  const [selectedCustomerID, setCustomerID] = useState<number>(getValues('customer.customerID') ?? 0);
  const { data, isLoading, isFetching } = useLoadData<ApiResponse<any>>(
    customersApiKeyStore.getCustomer(selectedCustomerID),
    selectedCustomerID !== 0
  );

  useEffect(() => {
    if (data && !office?.officeID && page == 'create') {
      setValue('requirePurchaseOrder', selectedCustomerID ? data?.data?.requirePurchaseOrder : '');
      setValue('rebates', selectedCustomerID ? data?.data?.rebates : '');
      setValue('syncWithDux', false);
    }
    onRebateValue(selectedCustomerID ? data?.data?.rebates : '');
    onCustomerLoading(isLoading || isFetching);
  }, [data, selectedCustomerID]);

  useEffect(() => {
    if (data) {
      setValue('syncWithDuxCustomer', selectedCustomerID ? data?.data?.isDuxSyncSuccess : false);
    }
  }, [data]);

  const handleCustomerChange = (value: any) => {
    setCustomerID(value ? value?.customerID : 0);
    onSelectCustomer(value ? value?.customerID : 0);
  };

  return (
    <FormAutoCompleteSelectDynamic
      name="customer"
      label="Customer"
      onChange={handleCustomerChange}
      getQueryKeyConfig={() => customersApiKeyStore.getCustomers()}
      optionsValueKey="customerID"
      optionsLabelKey="customerName"
      disabled={!!(office?.customerID || customerID)}
      required
    />
  );
};
